import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import StatusBar from "./StatusBar";
import TopNav from "./TopNav";
import SectionHeader from "./SectionHeader";
import Card, { CardContent } from "./TakashiCard";
import SparklineChart from "./SparklineChart";
import WatchlistPage from "./WatchlistPage"; 
import WatchlistManager from "./WatchlistManager";

import "./TakashiPlayground.css";
import stockData from "./stocks.json";

const TakashiPlayground = () => {
  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    setStocks(stockData);
  }, []);

  useEffect(() => {
    const cursor = document.getElementById("customCursor");

    const moveCursor = (e) => {
      if (cursor) {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener("mousemove", moveCursor);
    return () => {
      document.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  return (
    <div className="stock-watchlist">
      <StatusBar />
      <TopNav />
      <div className="cursor" id="customCursor"></div>

      {/* Routes for Watchlists */}
      <Routes>
        <Route index element={
          <div className="content">
            <SectionHeader title="Stocks" />
            <div className="stock-list">
              {stocks.map((stock) => (
                <Card key={stock.ticker} className="card">
                  <CardContent>
                    <div className="CompanyDetails">
                      <div className="ticker">
                        <div className="ticker-icon">
                          {stock.change >= 0 ? 
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M4.75159 1.4177L0.467344 9.98121C0.132919 10.6497 -0.0342931 10.9839 0.0058712 11.2556C0.0409428 11.4928 0.172243 11.7051 0.368875 11.8426C0.594059 12 0.967957 12 1.71575 12H10.2842C11.032 12 11.4059 12 11.6311 11.8426C11.8278 11.7051 11.9591 11.4928 11.9941 11.2556C12.0343 10.9839 11.8671 10.6497 11.5327 9.98121L7.24841 1.4177C6.8466 0.61455 6.64569 0.212972 6.37382 0.0841064C6.13724 -0.0280352 5.86276 -0.0280352 5.62618 0.0841064C5.35431 0.212972 5.1534 0.614549 4.75159 1.4177Z" fill="#0A8200"/>
                            </svg> 
                          : 
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M7.24841 10.5823L11.5327 2.01879C11.8671 1.35033 12.0343 1.0161 11.9941 0.744415C11.9591 0.507177 11.8278 0.294852 11.6311 0.157405C11.4059 5.19342e-08 11.032 8.46214e-08 10.2842 1.49996e-07L1.71575 8.99078e-07C0.967956 9.64452e-07 0.594058 9.97139e-07 0.368874 0.157406C0.172242 0.294853 0.0409422 0.507178 0.00586993 0.744416C-0.034294 1.0161 0.132918 1.35033 0.467342 2.01879L4.75159 10.5823C5.1534 11.3855 5.35431 11.787 5.62618 11.9159C5.86276 12.028 6.13724 12.028 6.37383 11.9159C6.64569 11.787 6.8466 11.3855 7.24841 10.5823Z" fill="#E10000"/>
                            </svg>}
                        </div>
                        <h2 className="font-semibold">{stock.ticker}</h2>
                      </div>
                      <p className="text-sm text-gray-500">{stock.name}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <SparklineChart data={stock.history} isPositive={stock.change >= 0} />
                    </div>
                    <div className="Stock-Details">
                      <p className="text-lg font-bold">${stock.price.toFixed(2)}</p>
                      <p className={stock.change >= 0 ? "text-green-500 font-semibold" : "text-red-500 font-semibold"}>
                        {stock.change >= 0 ? "▲" : "▼"} {stock.change.toFixed(2)}%
                      </p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        } />
        <Route path="watchlist/:watchlistId" element={<WatchlistPage />} />
      </Routes>
    </div>
  );
};

export default TakashiPlayground;
